import { PositionUrlConstant } from 'src/constants';
import { GetPositionListDto, GetPositionListResponseDto } from 'src/dtos';
import { ConfigService } from 'src/services';
import { replacePlaceholders, httpRequest } from 'src/utils';

export class PositionApi {
  private _configService: ConfigService;
  constructor(configService: ConfigService) {
    this._configService = configService;
  }

  list({ params }: GetPositionListDto): Promise<GetPositionListResponseDto> {
    const { accountId } = params;

    const url = replacePlaceholders(PositionUrlConstant.LIST, { accountId });

    return httpRequest<GetPositionListResponseDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });
  }
}
